<template>
  <div class="frame13_body">
    <div class="frame13">
      <div class="frame13_top">
        盈利能力-费用率
        <img
          src="../../../../public/img/shares_Info/close.png"
          alt=""
          @click="frame13_close"
        />
      </div>
      <div class="frame13_content">
        <div class="frame13_content_title">费用率</div>
        <div class="frame13_content_text">
          【释义】：销售费用率是指销售期间费用率反映生产成本以外的企业运营费用率。
        </div>
        <div class="frame13_content_text">【算法】：费用率=（营业费用+管理费用+研发费用+财务费用）/营业收入*100%</div>
        <div class="frame13_content_text">【单位】：%</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    frame13_close() {
      this.$emit("frame13_close");
    },
  },
};
</script>

<style scoped>
.frame13_body {
  width: 100vw;
  height: 100vh;
  position: fixed;
  left: 0;
  top: 0;
  overflow-y: scroll;
  z-index: 9999999;
}
.frame13 {
  width: 448px;
  height: 270px;
  background-color: #ffffff;
  box-shadow: 0px 2px 51px 6px rgba(0, 0, 0, 0.08);
  border-radius: 6px;
  padding: 30px 36px;
  margin: 50px auto;
  margin-top: 200px;
}
.frame13_top {
  width: 100%;
  height: 50px;
  border-bottom: 1px solid #f4f4f4;
  text-align: center;
  font-size: 20px;
  font-weight: bold;
}
.frame13_content {
  margin-top: 28px;
}
.frame13_top img {
  width: 19px;
  float: right;
  margin-top: 3px;
}
.frame13_content_title {
  font-size: 16px;
  font-weight: bold;
  color: #333333;
  line-height: 30px;
}
.frame13_content_text {
  font-size: 16px;
  font-weight: bold;
  color: #666666;
  line-height: 30px;
}
</style>